import { GlobalStateContext } from '../App'

import { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import BlockBanner from './BlockBanner'
import { getRawSpecsProduct, toProperCase } from './_uiHelpers'
import { configPresetUrl } from './_makeUrls'
import { backgroundColor, setFixedPageSizeMode } from './Global'
import { localize } from './_localization'

export default function SelectorGallery() {
	const { globalState } = useContext(GlobalStateContext)

	const [gallery, setGallery] = useState()

	useEffect(() => {
		setFixedPageSizeMode(false)

		const seriesSpecs = [
			['Wave', 'AW', 'B01'],
			['Cascade', 'AC', 'B01'],
			['Tide', 'AT', 'B01'],
			['Stream', 'AS', 'N01'],
			['Stream Double', 'AD', 'B01'],
			['Tabouret', 'UA', 'B01'],
			['Lumiere', 'CL', 'N01'],
			['Champignon', 'FC', 'N01'],
			['River', 'AF', 'B01'],
			['Swell', 'SW', 'N01'],
			['Glacier', 'GL', 'N01'],
			['LikeButter', 'LB', 'B01'],
		]

		const allRawLines = getRawSpecsProduct()
			.split('\n')
			.filter((line) => line.trim() !== '')
		allRawLines.shift() // eliminate the header row

		// get the friendly product names and associate them with the 'base' productId for that subproduct
		const idNameTriples = []
		allRawLines.forEach((rawId) => {
			const idComponents = rawId.split(':')
			const series = idComponents[0].trim()
			const subproduct = idComponents[1]
			const seriesSpec = seriesSpecs.find((spec) => spec[1] === series)
			const defaultAccent = seriesSpec[2]
			const baseId = `${series}.${defaultAccent}.${subproduct}`
			idNameTriples.push([baseId, toProperCase(localize(idComponents[2], globalState.language).trim()), idComponents[3]]) // baseID (e.g., AW), name (e.g., COFFEE TABLE), img source (e.g., COFFEE_CURVE_Mobile_B01_8a6cc9c52c)
		})

		setGallery(
			<div>
				{seriesSpecs
					.map((seriesTriple) => (
						<GalleryTitleDiv key={seriesTriple[1]}>
							<GalleryTitleText>{toProperCase(seriesTriple[0])}</GalleryTitleText>
							<GalleryRowDiv>
								{idNameTriples
									.filter((idTriple) => idTriple[0].startsWith(seriesTriple[1]))
									.map((productTriple) => (
										<Link
											to={configPresetUrl(productTriple[0], {})}
											target='_blank'
											style={{ alignSelf: 'center', textDecoration: 'none' }}
											key={productTriple[0]}
										>
											<ProductDiv>
												<ProductText>{productTriple[1]}</ProductText>
											</ProductDiv>
										</Link>
									))}
							</GalleryRowDiv>
						</GalleryTitleDiv>
					))}
			</div>
		)
	}, [globalState])

	return (
		<OuterDiv>
			<BlockBanner alwaysFullWidth={true} />
			<ContentDiv>
				{gallery}
			</ContentDiv>
		</OuterDiv>
	)
}

const OuterDiv = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

const ContentDiv = styled.div`
	padding-top: 50px;
	padding-left: 150px;
	background-color: ${backgroundColor};
`
const GalleryTitleDiv = styled.div``

const GalleryTitleText = styled.p`
	margin: 0;
	font-family: 'Sharp Sans No1 Bold';
	font-style: normal;
	// font-weight: 800;
	font-size: 24px;
	line-height: 32px;
	letter-spacing: 0.05em;
	color: black;
`

const GalleryRowDiv = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-contents: start;
`

const ProductDiv = styled.div`
	display: flex;
	flex-direction: column;
	margin: 20px;
	margin-top: 5px;
	width: 180px;
	background-color: black;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`
const ProductText = styled.p`
	height: 30px;
	margin: 0;
	align-self: center;
	font-family: 'Sharp Sans No1 Bold';
	font-style: normal;
	font-size: 14px;
	line-height: 32px;
	letter-spacing: 0.05em;
	color: white;
	background-color: black;
`
